<template lang="html">
  <div class="full-page">
    <i-header title="投资者基本信息" @leftClick="$_headerLeftClick">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <div class="natural-questions">
        <div class="natural-questions-form">
          <div class="natural-questions-form-item">
            <div class="natural-questions-form-item-title">
              一、您是否满足下列条件？ <br/>
              1）金融资产不低于500万元人民币，或者最近3年个人年均收入不低于50万元人民币;
                <br/>
              2）具有2年以上证券、基金、期货、黄金、外汇等投资经历，
                或者具有2年以上金融产品设计、投资、风险管理及相关工作经历的自然人投资者，
                或者属于《证券期货投资者适当性管理办法》第八条第（一）款所规定的专业投资者的高级管理人员、
                获得职业资格认证的从事金融相关业务的注册会计师和律师。
            </div>
            <div class="natural-questions-form-item-content">
              <cube-radio-group
                v-model="Model.userInvestmentExperienceChecked"
                :options="[
                  {label: '是', value: '是', disabled: true},
                  {label: '否', value: '否', disabled: true}
                ]"
                :horizontal="true">
              </cube-radio-group>
            </div>
          </div>

          <div class="natural-questions-form-item">
            <div class="natural-questions-form-item-title">
              二、私募基金或者资产管理计划投资者，
              最近20个交易日金融资产均不得低于人民币300万元，
              或者最近3年个人年均收入不低于人民币50万元
            </div>
            <div class="natural-questions-form-item-content">
              <cube-radio-group
                disabled
                v-model="Model.userAssetsScaleChecked"
                :options="[
                  {label: '是', value: '是', disabled: true},
                  {label: '否', value: '否', disabled: true}
                ]"
                :horizontal="true">
              </cube-radio-group>
            </div>

          </div>

          <div class="natural-questions-form-item">
            <div class="natural-questions-form-item-title">
              三、是否存在实际控制关系？
            </div>
            <div class="natural-questions-form-item-content">
              <cube-radio-group
                v-model="Model.isControllingShareholderChecked"
                :options="[
                  {label: '是', value: '是', disabled: true},
                  {label: '否', value: '否', disabled: true}
                ]"
                :horizontal="true">
              </cube-radio-group>
              <div class="natural-questions-form-item-content-desc">
                {{Model.isControllingShareholderDescription}}
              </div>
            </div>
          </div>

          <div class="natural-questions-form-item">
            <div class="natural-questions-form-item-title">
              四、交易的实际受益人？
            </div>
            <div class="natural-questions-form-item-content">
              <cube-radio-group
                v-model="Model.transactionActualBeneficiaryChecked"
                :options="[
                  {label: '本人', value: '本人', disabled: true},
                  {label: '他人', value: '他人', disabled: true}
                ]"
                :horizontal="true">
              </cube-radio-group>
              <div class="natural-questions-form-item-content-desc">
                {{Model.transactionActualBeneficiaryDescription}}
              </div>
            </div>

          </div>

          <div class="natural-questions-form-item">
            <div class="natural-questions-form-item-title">
              五、是否有不良诚信记录？
            </div>
            <div class="natural-questions-form-item-content">
              <cube-radio-group
                v-model="Model.isBadFaithChecked"
                :options="[
                  {label: '是', value: '是', disabled: true},
                  {label: '否', value: '否', disabled: true}
                ]"
                :horizontal="true">
              </cube-radio-group>
              <div class="natural-questions-form-item-content-desc">
                {{Model.isBadFaithDescription}}
              </div>
            </div>

          </div>
        </div>
      </div>
    </i-body>
  </div>
</template>

<script>
import cmixin from '../../commonConfig';

export default {
  data() {
    return {
      Model: {
        userInvestmentExperienceChecked: null,
        userAssetsScaleChecked: null,
        isControllingShareholderChecked: null,
        isControllingShareholderDescription: null,
        transactionActualBeneficiaryChecked: null,
        transactionActualBeneficiaryDescription: '',
        isBadFaithChecked: null,
        isBadFaithDescription: '',
      },
    };
  },
  mixins: [cmixin],
  mounted() {
    setTimeout(() => {
      this.$bridge.callHandler('getBaseInfo', { msg: '获取投资者问卷信息' }, (data) => {
        const obj = JSON.parse(data);
        console.log('详情', obj);
        this.$_handlerInit(obj.baseInfo);
      });
    }, 300);
  },
  methods: {
    /**
     * 初始数据
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    $_handlerInit(data) {
      const obj = JSON.parse(data);
      this.Model.userInvestmentExperienceChecked = JSON.parse(obj.userInvestmentExperience).checked;
      this.Model.userAssetsScaleChecked = JSON.parse(obj.userAssetsScale).checked;
      this.Model.isControllingShareholderChecked = JSON.parse(obj.isControllingShareholder).checked;
      this.Model.isControllingShareholderDescription = JSON.parse(obj.isControllingShareholder).description;
      this.Model.transactionActualBeneficiaryChecked = JSON.parse(obj.transactionActualBeneficiary).checked;
      this.Model.transactionActualBeneficiaryDescription = JSON.parse(obj.transactionActualBeneficiary).description;
      this.Model.isBadFaithChecked = JSON.parse(obj.isBadFaith).checked;
      this.Model.isBadFaithDescription = JSON.parse(obj.isBadFaith).description;
    },
  },
};
</script>

<style lang="scss" scoped>
.natural-questions {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  .natural-questions-form {
    .natural-questions-form-item {
      padding: 16px;
      background: #fff;
      margin-bottom: 10px;
      .natural-questions-form-item-title {
        font-size: 12px;
        margin-bottom: 8px;
        color: #666;
        line-height: 18px;
      }
      .natural-questions-form-item-content {
        .cube-validator-msg-custom {
          font-size: 12px;
          color: red;
          margin-top: 5px;
        }
        .natural-questions-form-item-content-desc {
          font-size: 13px;
          padding: 10px;
          color: #666;
        }
      }

    }
  }
}
</style>
